import { ChangeDetectionStrategy, Component, Input, OnDestroy } from '@angular/core';

import { Subscription } from 'rxjs';

import { VehicleService } from '@commons/services/vehicle/vehicle.service';
import { Driver } from '@commons/models/domain/Driver';

@Component({
  selector: 'app-driver-tacho',
  templateUrl: './driver-tacho.component.html',
  styleUrls: ['driver-tacho.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DriverTachoComponent implements OnDestroy {

  @Input('slotData') public set setSlotData(data: any) {
    this._slotData = {...(data || {})};
    if (data) {
      this.getDriverData();
    }
  }

  public _slotData?: any;
  public driver?: Driver;

  private readonly ComponentSubsc: Subscription = new Subscription();

  constructor(
    private $vehicleService: VehicleService
  ) { }

  ngOnDestroy(): void {
    this.ComponentSubsc.unsubscribe();
  }

  private getDriverData(): void {
    const sub = this.$vehicleService.getCurrentDriver$(this._slotData.Card).subscribe(driver => this.driver = driver);
    this.ComponentSubsc.add(sub);
  }

  public copyCardNumber(): void {
    navigator.clipboard.writeText(this._slotData.Card);
  }

}
